import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Intercom } from '@supy-io/ngx-intercom';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap, timeout } from 'rxjs/operators';
import { CaptchaService } from '../services/captcha.service';

@Injectable({
  providedIn: 'root',
})
export class Interceptor implements HttpInterceptor {
  parmaId: any;
  clarityToken: any;
  private captchaService: CaptchaService | null = null;

  constructor(
    private intercom: Intercom,
    private router: Router,
    public _routes: ActivatedRoute,
    private injector: Injector,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    req = this.applyHeaders(req);

    if (
      req.method.toUpperCase() === 'POST' &&
      this.getCaptchaService().requiresCaptcha(req.url)
    ) {
      return from(this.getCaptchaService().executeCaptcha()).pipe(
        switchMap((token) => {
          const captchaReq = req.clone({
            body: this.getCaptchaService().attachCaptchaToBody(req.body, token),
          });
          return next.handle(this.handleRequest(captchaReq));
        }),
        timeout(60000),
        catchError((err) => {
          if ([401, 403].indexOf(err.status) !== -1) {
            // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          }
          return throwError(err);
        })
      );
    }

    return next.handle(this.handleRequest(req)).pipe(
      timeout(60000),
      catchError((err) => {
        if ([401, 403].indexOf(err.status) !== -1) {
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        }
        return throwError(err);
      })
    );
  }

  private getCaptchaService(): CaptchaService {
    if (!this.captchaService) {
      this.captchaService = this.injector.get(CaptchaService);
    }
    return this.captchaService;
  }

  private applyHeaders(req: HttpRequest<any>): HttpRequest<any> {
    const currentLanguage = this.gt_get_cookie('googtrans').split('/').pop();
    const clckData: any = this.get_clck();
    const timezoneOffset = new Date().getTimezoneOffset() + '';

    if (clckData) {
      req = req.clone({
        headers: req.headers.append('x-clck-id', String(clckData[1])),
      });
    }

    const xToken = JSON.parse(localStorage.getItem('x-token'));
    if (xToken) {
      req = req.clone({
        headers: req.headers.append('x-token', xToken),
      });
    }

    req = req.clone({
      headers: req.headers.append('x-lan-code', currentLanguage || 'en'),
    });
    console.log(currentLanguage, 'currentLanguage');
    req = req.clone({
      headers: req.headers.append('x-timezone', timezoneOffset),
    });

    if (req.method.toLowerCase() === 'post') {
      req = req.clone({
        headers: req.headers.set('x-client-url', window.location.href),
      });
    }

    return req;
  }

  private handleRequest(req: HttpRequest<any>) {
    if (req.method === 'POST') {
      let body = req.body;
      if (typeof req.body === 'string') {
        body = body.split('&').filter((d) => d);
        return req.clone({
          body: body.join('&'),
        });
      } else {
        return req.clone({
          body: body,
        });
      }
    }
    return req;
  }

  private gt_get_cookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      // tslint:disable:triple-equals
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  private get_clck() {
    const decodedCookie = decodeURIComponent(document.cookie);

    const ca = decodedCookie.split(';');
    const d = ca.find((i) => {
      const clck = i.includes('_clck');
      return clck;
    });
    const clck = d && d.split('=');
    return clck;
  }
}
